<template>
  <div class="row_start_start w-full" @click="click">
    
    <div class="column_start_around overflow-hidden flex-grow h-[110px] ml-2.5 px-2">
      <div class="row_center_start w-full">
         <div v-if="cartQuantity" class="row_center_center quantity mr-2">{{ cartQuantity }}</div>
        <text class="title truncate">{{ product.name }}</text>
      </div>
      <div class="w-full py-1.5">
        <text class="text-sm text-[#666666] text_two_lines">{{  truncateDesc (productDescription) }}</text>
      </div>
      <div class="row_center_end" style="width: 100%; font-size: 14px; color: #fd5001">
        ${{ product.price }}
      </div>
    </div>
   
    <!-- 圖片區域 -->
    <div class="column_start_start shrink-0" :class="productImage ? 'w-[110px]' : 'w-0'">
      <img v-if="productImage" :src="productImage" class="h-[110px] w-full rounded-xl" />
    </div>

  </div>
</template>
<script>
export default {
  props: {
    product: {
      type: Object,
      default: () => {
        return {};
      },
      required: true,
    },
    icon: {
      type: String,
      default: "@/assets/product_example_img.png",
      required: false,
    },
    cartQuantity: {
      type: Number,
      default: 0,
      required: false,
    },
  },
  computed: {
    productImage() {
      // TODO: 之後改回從 API 取得圖片
      return this.$store.getters['product/getProductImageById'](this.product.id)
      // return require('@/assets/product_example_img.png')
    },
    productDescription() {
      // 使用新的 getter 來取得描述，會自動判斷使用哪個資料來源
      return this.$store.getters['product/getProductDescById'](this.product.id)
    }, 
  },
  methods: {
    click() {
      this.$emit("click");
    },
    truncateDesc (content) {
  if (!content) return ''
  
  // 1. 移除 HTML 標籤
  let text = content.replace(/<[^>]*>/g, '').trim()
  
  // 2. 解碼 HTML 實體字符
  const textarea = document.createElement('textarea')
  textarea.innerHTML = text
  text = textarea.value
  
  return text
}
  }
};
</script>
<style lang="scss">
.quantity_container {
  border-radius: 50%;
  width: 0px;
  height: 0px;
  position: relative;
  top: 0;
  left: 0;
}

.quantity {
  border-radius: 50%;
  width: 32px;
  height: 32px;
  background-color: #D60A0A;
  flex-shrink: 0;
  color: #fff;
  font-size: 18px;
  font-weight: 500;
  font-family: PingFang SC;
}
</style>
